export default __webpack_public_path__ + "static/media/404morpheus.d030629c.png";